export type AdminSession = {
  apiKey: string;
  name: string;
  expiresAt: number;
};

const STORAGE_KEY = 'admin_session_v1';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export function setAdminSession(apiKey: string, name: string): void {
  const session: AdminSession = {
    apiKey,
    name,
    expiresAt: Date.now() + MAX_AGE_MS,
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function getAdminSession(): AdminSession | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as AdminSession;
    if (!parsed?.apiKey || !parsed?.expiresAt) return null;

    if (Date.now() > parsed.expiresAt) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return parsed;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearAdminSession(): void {
  localStorage.removeItem(STORAGE_KEY);
}

